import { useContext } from "react";

import DruidWebchatContext, { DruidWebchatContextType } from "../WebChatContext";
import { useMergedOptions } from '../selectors/useMergedOptions';

export const useStaticDruidStyleSet = ({ outerBFSuggestedActions }: { outerBFSuggestedActions: any[] }) => {
    const [druidWebChatState, , ,] = useContext<DruidWebchatContextType>(DruidWebchatContext);
    const { UI = {},  UI: { restylingsEnabled, transcriptLinkColor, buttonsPadding, druidSendBoxTextBoxPadding, buttonsBorderRadius, buttonsBorderColor, buttonsBackgroundColor, chatBoxBorderRadius, buttonsBackgroundColorOnHover, buttonsTextColorOnHover, buttonsBorderColorOnHover, buttonsTextColor, transcriptFontSize, rootFontSize,  activityStatusShowBotName, activityStatusBotName, activityStatusUserName, activityStatusShowUserName } = {},
        styleOptions= {}, styleOptions: { accent, suggestedActionBackgroundColor, suggestedActionTextColor, fontSizeSmall, subtle, paddingRegular, sendBoxHeight, suggestedActionBackgroundColorOnDisabled, suggestedActionTextColorOnDisabled, suggestedActionBorderColorOnDisabled, sendBoxButtonColorOnDisabled, sendBoxDisabledTextColor, bubbleBorderRadius,sendBoxBackground } = {}, disabled,
        designPatterns: { nonCarousel_HeroCard_AutoWidth, nonCarousel_HeroCard_ButtonsOnly_BackgroundTransparent } = {}
    } = useMergedOptions();

    const scrollbarStyling = {
        '&::-webkit-scrollbar': {
            width: 8
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: 'rgb(219, 222, 225)',
            borderRadius: chatBoxBorderRadius
        }
    };
    return {
        basicTranscript: {
            '.druidWebchatRoot_v2 &': {
                '&.webchat__basic-transcript': {
                    overscrollBehavior: 'contain',
                    fontSize: transcriptFontSize || rootFontSize,
                    '.webchat__basic-transcript__scrollable': {
                        overscrollBehavior: 'none',
                         ...scrollbarStyling
                    }
                }

            },
            // REMOVED: message from bot and user should be aligned
            // 'div[class$="__nub-pad"]': !druidWebChatState.mergedChatOptions.styleOptions?.botAvatarImage  && { // if nubSize == 0 -> hide nub padding
            //     width: '0 !important'
            // },
            // must be with ID #druidWebchatRoot_v2 (or be more specific. was done below at adaptiveCardRenderer)
            // '#druidWebchatRoot_v2 & .ac-pushButton': { // could/should have used adaptiveCardRenderer from createStyleSet -> createAdaptiveCardsStyleSet
            //     padding: `${buttonsPadding}px`,
            //     borderRadius: `${buttonsBorderRadius}px`,
            //     fontSize: transcriptFontSize || rootFontSize, // possible bug fixes for not scrolling to bottom
            //     fontWeight: '400', // possible bug fixes for not scrolling to bottom
            //     // adaptivecards.css overrides. ex: height: 31px is wrong.
            //     height: 'auto',
            //     fontFamily: 'inherit',
            //     '&:not([aria-disabled="true"])' : {
            //         borderColor: `${buttonsBorderColor}`,
            //         backgroundColor: `${buttonsBackgroundColor}`,//?.startsWith("$") ? (styleOptions[buttonsBackgroundColor.replace('$','')]) : buttonsBackgroundColor}`,
            //         color: buttonsTextColor,
            //         cursor: 'pointer',
            //         '&:hover': {
            //             backgroundColor: `${buttonsBackgroundColorOnHover || buttonsTextColor}`,
            //             color: buttonsTextColorOnHover || buttonsBackgroundColor,
            //             borderColor: `${buttonsBorderColorOnHover}` || 'transparent'
            //         }
            //     },
            //     '&[aria-pressed="true"]' : {
            //         backgroundColor: `${buttonsBackgroundColorOnHover || buttonsTextColor}`,
            //         color: buttonsTextColorOnHover || buttonsBackgroundColor,
            //         borderColor: buttonsBorderColor || 'transparent',
            //         // SHOULD consider using bellow for after button pressed
            //         // [aria-pressed="true"]': {
            //         //     backgroundColor: cardPushButtonBackgroundColor,
            //         //     borderColor: cardPushButtonBackgroundColor,
            //         //     color: cardPushButtonTextColor
            //         //   }
            //     },
                
            // },
            '.druidWebchatRoot_v2 & button:not([aria-disabled="true"])': {
                cursor: 'pointer'
            },
            '.druidWebchatRoot_v2 & a': {
                textDecoration: 'none',
                '&[href]': {
                    color: transcriptLinkColor,
                    '&:visited': {
                        color: transcriptLinkColor
                    }
                }
            }
        },
        stackedLayout: {
            '.druidWebchatRoot_v2 &.webchat__stacked-layout:not(.webchat__stacked-layout--from-user)': {
                '& .webchat__stacked-layout__attachment': {
                    width: nonCarousel_HeroCard_AutoWidth && 'auto',
                    '& .webchat__bubble__content.druid-hero-card__buttons-only': {
                        backgroundColor: nonCarousel_HeroCard_ButtonsOnly_BackgroundTransparent && 'Transparent',
                        border: nonCarousel_HeroCard_ButtonsOnly_BackgroundTransparent && 0,
                        borderRadius: nonCarousel_HeroCard_ButtonsOnly_BackgroundTransparent && 0,
                        '& .webchat__adaptive-card-renderer': {
                            '& .ac-adaptiveCard': {
                                paddingLeft: nonCarousel_HeroCard_ButtonsOnly_BackgroundTransparent && '0 !important',
                                paddingRight: nonCarousel_HeroCard_ButtonsOnly_BackgroundTransparent && '0 !important',
                                paddingTop: nonCarousel_HeroCard_ButtonsOnly_BackgroundTransparent && '0 !important',
                            }
                        }
                    }
                }
            }
        },
        suggestedActions: {
            '&.webchat__suggested-actions': {
                fontSize: transcriptFontSize || rootFontSize,
                '& .webchat__suggested-actions__flow-box': {
                    justifyContent: outerBFSuggestedActions?.length <= 2 && 'center'
                }
            },
        },
        suggestedAction: {
            '#druidWebchatRoot_v2 &.webchat__suggested-action': {
                    padding: buttonsPadding,
                    '&:not([aria-disabled="true"])' :{
                        cursor: 'pointer',
                        '&:hover': {
                            backgroundColor: `${buttonsBackgroundColorOnHover || suggestedActionTextColor}`,
                            color: buttonsTextColorOnHover || suggestedActionBackgroundColor,
                            borderColor: buttonsBorderColorOnHover || buttonsBackgroundColorOnHover || suggestedActionTextColor
                        }
                    },
                    '&[aria-disabled="true"]': {
                        backgroundColor: suggestedActionBackgroundColorOnDisabled || sendBoxButtonColorOnDisabled,
                        color: suggestedActionTextColorOnDisabled || sendBoxDisabledTextColor,
                        borderColor: suggestedActionBorderColorOnDisabled || sendBoxButtonColorOnDisabled
                    }
            }
        },
        scrollToEndButton: {
            '#druidWebchatRoot_v2 &.webchat__scroll-to-end-button': {
                padding: paddingRegular! / 2,
                opacity: '70%'
            },
        },
        toast: {
            '& .webchat__toast__text':{
                textAlign: 'center'
            }
        },
        autoResizeTextArea: {
            '&.webchat__auto-resize-textarea':{
                'textarea.webchat__auto-resize-textarea__textarea': {
                    ...scrollbarStyling
                },
                '& .webchat__auto-resize-textarea__doppelganger': {
                    overflowY: 'none'
                }
            },
            
        },
        adaptiveCardRenderer: {
            '&.webchat__adaptive-card-renderer .ac-adaptiveCard': {
                '& *': {
                    fontFamily: 'inherit !important'
                },
                'select.ac-multichoiceInput': {
                    // select has a problem with height.
                    height: `calc(${paddingRegular! + 2}px + ${rootFontSize} + 5px)`,
                    padding: paddingRegular! / 2
                },
                '& .ac-pushButton': { // could/should have used adaptiveCardRenderer from createStyleSet -> createAdaptiveCardsStyleSet
                    padding: `${buttonsPadding}px`,
                    borderRadius: `${buttonsBorderRadius}px`,
                    fontSize: transcriptFontSize || rootFontSize, // possible bug fixes for not scrolling to bottom
                    fontWeight: '400', // possible bug fixes for not scrolling to bottom
                    // adaptivecards.css overrides. ex: height: 31px is wrong.
                    height: 'auto',
                    fontFamily: 'inherit',
                    '&:not([aria-disabled="true"])' : {
                        borderColor: `${buttonsBorderColor}`,
                        backgroundColor: `${buttonsBackgroundColor}`,//?.startsWith("$") ? (styleOptions[buttonsBackgroundColor.replace('$','')]) : buttonsBackgroundColor}`,
                        color: buttonsTextColor,
                        cursor: 'pointer',
                        '&:hover': {
                            backgroundColor: `${buttonsBackgroundColorOnHover || buttonsTextColor}`,
                            color: buttonsTextColorOnHover || buttonsBackgroundColor,
                            borderColor: `${buttonsBorderColorOnHover}` || 'transparent'
                        }
                    },
                    '&[aria-pressed="true"]' : {
                        backgroundColor: `${buttonsBackgroundColorOnHover || buttonsTextColor}`,
                        color: buttonsTextColorOnHover || buttonsBackgroundColor,
                        borderColor: buttonsBorderColor || 'transparent',
                        // SHOULD consider using bellow for after button pressed
                        // [aria-pressed="true"]': {
                        //     backgroundColor: cardPushButtonBackgroundColor,
                        //     borderColor: cardPushButtonBackgroundColor,
                        //     color: cardPushButtonTextColor
                        //   }
                    },
                },
                '& .ac-textBlock, & .ac-textRun': {
                    // fontFamily: 'inherit !important'
                },
                '& .ac-input': {
                    // fontFamily: 'inherit',
                    // color: 'black',
                    '&.ac-textInput' : {
                        resize: 'none',
                        '&.ac-multiline' : {
                            height: 72
                        }
                    },
                    '&.ac-textInput, &.ac-numberInput, &.ac-dateInput, &.ac-timeInput, &.ac-multichoiceInput': {
                        border: '1px solid #DDDDDD',
                        boxSizing: 'border-box',
                        padding: '4px 8px 4px 8px',
                        height: 31
                    },
                    '&.ac-multichoiceInput': {
                        backgroundColor: 'white'
                    }
                }
            }
        },
        fileContent: {
            '& .webchat__fileContent__downloadIcon': {
                padding: 0 // if css box-size: border-box + padding: 20px -> icon is not visible. useless padding if not overriden
            },
            '& .webchat__fileContent__fileName': {
                color: 'inherit'
            }
        },
        sendBox: {
            '&.webchat__send-box': {
                ...(restylingsEnabled && 
                { 
                    '& .webchat__send-box__main': {
                        backgroundColor: 'transparent',
                        gap:  ((paddingRegular || 0) / 2)
                    }
                })
            }
        },
        sendBoxTextBox: {
            '&.webchat__send-box-text-box': {
                flex: 10000,
                padding: druidSendBoxTextBoxPadding || ((paddingRegular || 0) / 2),
                ...(restylingsEnabled && 
                    { 
                            backgroundColor: sendBoxBackground,
                            borderRadius: bubbleBorderRadius,
                            paddingInline: paddingRegular,
                            '& .webchat__send-box-text-box__input': {
                            
                            },

                            '& .webchat__send-box-text-box__input, & .webchat__send-box-text-box__html-text-area': {
                                // backgroundColor: 'red'
                            }
                    }),
            }
        },
        sendBoxButton: {
            '&.webchat__icon-button .webchat__icon-button__shade': {
                display: !restylingsEnabled && 'none'
            },
            ...(restylingsEnabled && 
                { 
            '&.webchat__icon-button': {
                // borderRadius: '50%',
                marginBlock: 5,
                // alignSelf: 'center',
                // color: accent,
                '&.webchat__send-button': {
                    // marginLeft: 10
                },
                //UNCOMMENT
                '& .webchat__icon-button__shade': {
                    display: 'block',
                    top: 'unset',
                    bottom: 'unset',
                    left: 'unset',
                    right: 'unset',
                    width: sendBoxHeight ? parseInt(sendBoxHeight.toString()) - 10 : sendBoxHeight, // We use the sendBoxHeight, so the button looks square
                    height: sendBoxHeight ? parseInt(sendBoxHeight.toString()) - 10 : sendBoxHeight

                },
                width: sendBoxHeight ? parseInt(sendBoxHeight.toString()) - 10 : sendBoxHeight, // We use the sendBoxHeight, so the button looks square

                '&:not(.webchat__icon-button--stretch)': {
                  height: sendBoxHeight ? parseInt(sendBoxHeight.toString()) - 10 : sendBoxHeight
                },

                // '&:not(.webchat__icon-button--stretch)': {
                //     height: sendBoxHeight ? parseInt(sendBoxHeight.toString()) - 10 : sendBoxHeight,
                //     '& .webchat__icon-button__shade': {
                //         display: 'block',
                //         top: 0,
                //         left: 0,
                //         right: 0,
                //         bottom: 0
                //     }
                // },
                // '.webchat__icon-button__shade': {
                //     display: 'block',
                //     position: 'absolute',
                //     top: 'unset',
                //     bottom: 'unset',
                //     left: 'unset',
                //     right: 'unset',
                // },
                // width: sendBoxHeight ? parseInt(sendBoxHeight.toString()) - 10 : sendBoxHeight,
            },
        }),
        },
        uploadButton: {
            // marginInline: 10,
            ...(restylingsEnabled && 
                {
                    width: sendBoxHeight ? parseInt(sendBoxHeight.toString()) - 5 : sendBoxHeight,
                })
        }
        // bubble: {
        //   '&.webchat__bubble': {
        //     '&.webchat__bubble--hide-nub, &.webchat__bubble--show-nub': {
        //       // '& .webchat__bubble__nub-pad': {
        //       '& [class$="__nub-pad"]': {
        //         width: '0 !important'
        //       }
        //     }
        //   }
        //  }
    };
}